import { PublicEducator } from '@cademy-package/sdk-component-types';
import { FunctionComponent } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import styles from './styles.module.scss';
import ReactHTML from '../../../components/ReactHTML';
import { MarkerIcon } from '../../../components/Icons';
import classNames from 'classnames';
import StarRatingWithCount from '../../../components/StarRatingWithCount';

export type EducatorSectionProps = {
    educator: PublicEducator;
};

export const EducatorSection: FunctionComponent<EducatorSectionProps> = ({ educator }) => {
    return (
        <section className={styles.educator_section} aria-labelledby="educator-heading">
            <h2 id="educator-heading">About The Provider</h2>
            <div className={styles.educator_section_inner}>
                <div className={styles.mainInfo}>
                    {educator.logo_url ? (
                        <Link
                            href={`/${educator.slug}/courses`}
                            aria-label="Educator Page"
                            className={classNames('rounded_image', styles.educator_logo)}
                        >
                            <Image src={educator.logo_url} alt={educator.name} fill sizes="50px" />
                        </Link>
                    ) : null}
                    <div>
                        <Link
                            href={`/${educator.slug}/courses`}
                            aria-label="Educator Page"
                            className={styles.educator_name_link}
                        >
                            {educator.name}
                        </Link>
                        <div className={styles.locationAndRatingContainer}>
                            {educator.address && educator.address.city ? (
                                <div className={styles.educator_city}>
                                    <span>
                                        <MarkerIcon height={14} width={14} />{' '}
                                        {educator.address.city}
                                    </span>
                                </div>
                            ) : null}
                            {educator.review_aggregate && educator.review_aggregate.count > 0 ? (
                                <StarRatingWithCount
                                    rating={educator.review_aggregate.rating}
                                    count={educator.review_aggregate.count}
                                />
                            ) : null}
                        </div>
                    </div>
                </div>
                <div className={styles.educatorBio}>
                    {educator.bio && educator.bio.length ? (
                        <div className={styles.educator_bio}>
                            <div>
                                {educator.bio ? (
                                    <ReactHTML
                                        html={
                                            educator.bio.length > 280
                                                ? educator.bio.substring(0, 280).trim() + '...'
                                                : educator.bio
                                        }
                                    />
                                ) : null}
                            </div>
                            <Link href={`/${educator.slug}`}>Read more about {educator.name}</Link>
                        </div>
                    ) : null}
                </div>
            </div>
        </section>
    );
};

export default EducatorSection;
